import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { FilterCondition } from "@/components/customTable/types";

interface UseAdvancedFiltersProps {
	conditions: FilterCondition[];
	setConditions: (conditions: FilterCondition[]) => void;
}

export function useAdvancedFilters({ conditions, setConditions }: UseAdvancedFiltersProps) {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [searchParams, setSearchParams] = useSearchParams();

	const addCondition = (condition: FilterCondition) => {
		const newConditions = [...conditions, condition];
		setConditions(newConditions);
	};

	const removeCondition = (index: number) => {
		const newConditions = conditions.filter((_, i) => i !== index);
		setConditions(newConditions);
	};

	const updateCondition = (index: number, condition: FilterCondition) => {
		const newConditions = [...conditions];
		newConditions[index] = condition;
		setConditions(newConditions);
	};

	const updateConditions = (newConditions: FilterCondition[]) => {
		setConditions(newConditions);
	};

	const resetFilters = () => {
		setConditions([]);
		searchParams.delete("filters");
		setSearchParams(searchParams);
	};

	const openDrawer = () => {
		setIsDrawerOpen(true);
	};

	const closeDrawer = () => {
		setIsDrawerOpen(false);
	};

	const applyFilters = (newConditions: FilterCondition[]) => {
		setConditions(newConditions);

		if (newConditions.length > 0) {
			searchParams.set("filters", JSON.stringify(newConditions));
		} else {
			searchParams.delete("filters");
		}
		setSearchParams(searchParams);
		// closeDrawer();
	};

	const getFiltersAsJson = () => {
		return JSON.stringify(conditions);
	};

	const getFiltersAsQueryString = () => {
		if (conditions.length === 0) return "";
		return `filter=${encodeURIComponent(JSON.stringify(conditions))}`;
	};

	return {
		conditions,
		isDrawerOpen,
		addCondition,
		removeCondition,
		updateCondition,
		setConditions: updateConditions,
		resetFilters,
		openDrawer,
		closeDrawer,
		applyFilters,
		getFiltersAsJson,
		getFiltersAsQueryString,
	};
}
